import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ProductReleaseCommentDialogResponse } from './product-release-comment-dialog-response.model';
import { AppBackgroundOverlayService } from '../../services';

@Injectable({ providedIn: 'root' })
export class ProductReleaseCommentDialogService {


    public message$: BehaviorSubject<string> = new BehaviorSubject('');
    public aiComment$: BehaviorSubject<string> = new BehaviorSubject('')
    public response$: Subject<ProductReleaseCommentDialogResponse> = new Subject();
    public showDialog$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public styleVariableScale: number = 1;

    constructor(
        private appBackgroundOverlayService: AppBackgroundOverlayService
    ) { }

    displayDialog(message: string, aiComment: string) {
        this.message$.next(message);
        this.appBackgroundOverlayService.overlayDisplayed$.next(true);
        this.showDialog$.next(true);
        this.aiComment$.next(aiComment)
    }

    destroyDialog() {
        this.styleVariableScale = 1;
        this.showDialog$.next(false);
        this.appBackgroundOverlayService.overlayDisplayed$.next(false);
        this.response$ = new Subject();
    }

}